module.exports = __webpack_public_path__ + "images/16292-INT2-Cam01-d138379fd70752f01612d5c4b7bc5a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/16292-INT2-Cam01.jpg
// module id = 31
// module chunks = 0